import { watchFetchCompanies } from './companies'
import { watchFetchLoginToConfiguration } from './loginToConfiguration'
import { watchFetchClients} from './clients'
import { watchFetchUnits} from './units'
import { watchFetchProtocols} from './protocols'
import { watchFetchLoginAdm} from './loginAdm'
import { watchFetchRegisterPoint} from './registerPoint'
import { watchFetchFindDataByRe} from './findDataByRE'
import { watchFetchRegistrarPontoComLogin } from './registrarPontoComLogin'
import { watchFetchAtualizarSenha } from './atualizarSenha'
import { watchFetchSalvarConfiguracoesComLogin } from './salvarConfiguracoesComLogin'
import { watchFetchCheckGeo } from './checkGeo'
import { watchFetchValidateUser } from './userValidation'
import { watchFetchBaterPonto } from './baterPonto'
import { watchFetchFindCoordsByUnit } from './findCoordsByUnit'
import { watchFetchCurrentTime } from './currentTime'
import { watchFetchRegistrarInfo } from './registrarinfo'
import { watchFetchProtocolsDate } from './protocolsByDate'
import { watchFetchSendSms } from './sendSms'
import { watchFetchValidarDispositivo } from './validarDispositivo'
import { watchFetchCreateDispositivo } from './createDispositivo'
import { watchFetchHabilitarDispositivo } from './habilitarDispositivo'
import { watchFetchProtocolsByMonth } from './getProtocolsByMonth'

import { all } from 'redux-saga/effects'

export default function* rootSaga() {
    yield all([
        watchFetchCompanies(),
        watchFetchLoginToConfiguration(),
        watchFetchClients(),
        watchFetchUnits(),
        watchFetchProtocols(),
        watchFetchLoginAdm(),
        watchFetchRegisterPoint(),
        watchFetchFindDataByRe(),
        watchFetchRegistrarPontoComLogin(),
        watchFetchAtualizarSenha(),
        watchFetchSalvarConfiguracoesComLogin(),
        watchFetchCheckGeo(),
        watchFetchValidateUser(),
        watchFetchBaterPonto(),
        watchFetchFindCoordsByUnit(),
        watchFetchCurrentTime(),
        watchFetchRegistrarInfo(),
        watchFetchProtocolsDate(),
        watchFetchSendSms(),
        watchFetchValidarDispositivo(),
        watchFetchCreateDispositivo(),
        watchFetchHabilitarDispositivo(),
        watchFetchProtocolsByMonth(),
    ])
}